import ListingTabBodies from "@/Components/shared/ListingTabBodies"
import { Tabs, TabsList } from "@/Components/ui/tabs"
import { Seo } from "@/Components/Seo"
import { CardPreload } from "@/Components/Common/CardPreload"
import FilterSidebar from "@/Components/filter/FilterSidebar"
import ListingTabTrigger from "@/Components/Brands/ListingTabTrigger"
import WatchlistEmptyState from "@/Components/shared/WishlistEmptyState"
import FilteredListingEmptyState from "@/Components/shared/FilteredListingEmptyState"
import useListingDefaultTab from "@/Hooks/useListingDefaultTab"
import SiteLayout from "@/Layouts/SiteLayout"

export default function AuctionIndex({
    title,
    description,
    schemas,
    ogImage = null,
    liveAuctions = [],
    liveMeta,
    recentlySold = [],
    soldMeta,
    filterOptions,
    activeFilters,
    filterContext,
}) {
    const liveTotal = liveMeta?.total ?? 0
    const defaultTab = useListingDefaultTab()
    // The LCP element: the first card of whichever list the default tab shows
    // (mirrors ListingTabBodies' live-first-with-sold-fallback ordering).
    const firstCard = (defaultTab === "sold" || liveTotal === 0
        ? recentlySold
        : liveAuctions)[0]
    return (
        <SiteLayout>
            <Seo
                title={title}
                description={description}
                image={ogImage}
                schemas={schemas}
            />
            <CardPreload src={firstCard?.gun?.photo_array?.[0]} />

            <section className="flex flex-col w-full gap-4 px-5 xl:px-10 py-10 pb-5 mx-auto max-w-[1440px]">
                <header className="flex flex-col">
                    <h1 className="text-[32px] font-bold">Firearm Auctions</h1>
                    <p className="text-sm font-semibold text-gray-500">
                        Browse every live and recently sold auction on
                        FirearmLand across all brands and categories.
                    </p>
                </header>
            </section>
            <section className="w-full px-5 xl:px-10 pb-16 mx-auto max-w-[1440px]">
                <Tabs defaultValue={defaultTab} className="gap-0">
                    <div className="flex flex-col items-start gap-4 md:flex-row md:mt-4">
                        <div className="w-full mt-2 sticky md:top-[120px] top-[105px] pt-[20px] md:pt-0 z-30 bg-white pb-2 md:w-auto md:self-start  md:z-auto md:bg-transparent md:pb-0">
                            <div className="flex items-center gap-2 md:block">
                                <TabsList className="flex-1 h-auto border shadow-sm md:w-full md:mb-4">
                                    <ListingTabTrigger
                                        value="all"
                                        position="first"
                                    >
                                        All
                                    </ListingTabTrigger>
                                    <ListingTabTrigger value="active">
                                        Active ({liveTotal})
                                    </ListingTabTrigger>
                                    <ListingTabTrigger
                                        value="sold"
                                        position="last"
                                    >
                                        Sold
                                    </ListingTabTrigger>
                                </TabsList>
                                <FilterSidebar
                                    options={filterOptions}
                                    initial={activeFilters}
                                    context={filterContext}
                                />
                            </div>
                        </div>

                        <ListingTabBodies
                            liveAuctions={liveAuctions}
                            liveMeta={liveMeta}
                            recentlySold={recentlySold}
                            soldMeta={soldMeta}
                            liveTitle="Live Auctions"
                            liveSubtitle={`${liveTotal} active auctions ending soon`}
                            liveEmptyMessage="No active auctions right now."
                            soldEmptyMessage="No recently sold auctions."
                            emptyState={
                                <FilteredListingEmptyState
                                    activeFilters={activeFilters}
                                    fallback={
                                        <WatchlistEmptyState
                                            message="No active auctions right now."
                                            activeFilters={activeFilters}
                                            context={filterContext}
                                        />
                                    }
                                />
                            }
                        />
                    </div>
                </Tabs>
            </section>
        </SiteLayout>
    )
}
